import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <h5 className="font-bold text-lg mb-4">Our Company</h5>
            <ul className="space-y-2">
              <li>
                <Link to="/about-us" className="text-gray-600 hover:text-black transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/our-services" className="text-gray-600 hover:text-black transition-colors">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-black transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="font-bold text-lg mb-4">Quick Links</h5>
            <ul className="space-y-2">
              <li>
                <Link to="/our-services" className="text-gray-600 hover:text-black transition-colors">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/about-us" className="text-gray-600 hover:text-black transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-black transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="font-bold text-lg mb-4">Contact Us</h5>
            <ul className="space-y-2">
              <li>
                <Link to="/our-services" className="text-gray-600 hover:text-black transition-colors">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/about-us" className="text-gray-600 hover:text-black transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-black transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="font-bold text-lg mb-4">Subscribe to our Newsletter</h5>
            <p className="text-gray-600 text-sm mb-4">
              Stay up to date with our latest offers and destinations.
            </p>
            <form className="flex gap-2" data-readdy-form id="newsletter-form">
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-2 border border-gray-300 rounded text-sm focus:outline-none focus:border-blue-600"
                required
              />
              <button
                type="submit"
                className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-600 text-sm">
              © 2025 Milajet Havacilik. All rights reserved.
            </p>

            <div className="flex gap-6">
              <Link to="/terms" className="text-gray-600 hover:text-black text-sm transition-colors">
                Terms and Conditions
              </Link>
              <Link to="/privacy" className="text-gray-600 hover:text-black text-sm transition-colors">
                Privacy Policy
              </Link>
            </div>

            <div className="flex gap-4">
              <a href="#" className="text-gray-600 hover:text-black transition-colors cursor-pointer" target="_blank" rel="noopener noreferrer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-600 hover:text-black transition-colors cursor-pointer" target="_blank" rel="noopener noreferrer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-600 hover:text-black transition-colors cursor-pointer" target="_blank" rel="noopener noreferrer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center py-4 border-t border-gray-200">
        <a 
          href="https://www.websitemkolay.com" 
          className="text-gray-500 text-sm hover:text-gray-700 transition-colors"
          target="_blank"
          rel="noopener noreferrer"
        >
          WebsitemKolay
        </a>
      </div>
    </footer>
  );
}
